import { Component, ViewChild } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM, typesApex } from '../../../components/models';
import { TranslateService } from '@ngx-translate/core';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';
import {
  AnonymousResultCategory,
  AnonymousResultPeriod,
  AnonymousResults,
  AnonymousResultsCross,
  CrossCategory,
  DemographicBreakdown,
  DemographicValue,
  ResultadosClimaService,
} from '../../../services/cuestionarios/resultados-clima/resultados-clima.service';

@Component({
  selector: 'app-resultados',
  templateUrl: './resultados.component.html',
  styleUrl: './resultados.component.css'
})
export class ResultadosComponent {
  cuestionario_name = '';
  private semaforos = [];

  private institutionId = '';
  private questionnaireId = '';
  /** Máximo real de ponderación de la institución (Instituciones.maximoClimaLaboral); para %s de barras */
  public maximoPonderacion = 5;

  public Filters = FiltersM;
  public loadingResultados = false;
  public periodos: any[] = [];
  public periodoSelect = '';
  private allocationSelect: number | null = null;

  private resultado: AnonymousResults | null = null;

  /** Periodos del cuestionario, asc por fecha (para encontrar el anterior) */
  private periodosPropios: AnonymousResultPeriod[] = [];
  /** Resultados del periodo anterior (para el comparativo) */
  private resultadoPrevio: AnonymousResults | null = null;

  /** Cards de comparación (actual vs anterior); re-escopa por Sucursal, no por Dimensión */
  public comparativo: {
    actual: { label: string; score: number | null; tendencia: 'up' | 'down' | 'eq' | null };
    anterior: { label: string; score: number | null } | null;
  } | null = null;

  /** Vista de una dimensión seleccionada (reemplaza las cards de consolidado) */
  public vistaDimension: {
    dimension: string;
    universo: number;
    muestra: number;
    muestraPct: number;
    sucLabel: string;
    score: number | null;
    actual: number | null;
    anterior: number | null;
    anioActual: string;
    anioAnterior: string | null;
    tendencia: 'up' | 'down' | 'eq' | null;
  } | null = null;

  public sucursales: { name: string; check: boolean }[] = [];
  public sucursalConsolidado = true;
  /** Hay sucursales REALES (ignora placeholders); si no, el filtro queda en consolidado */
  public sucursalesDisponibles = false;

  /** Placeholders que NO cuentan como sucursal real */
  private static readonly SUCURSAL_PLACEHOLDERS = ['No especificado', 'Sin dato'];
  private static readonly KEY_SUCURSAL = 'branch-office';

  /** Azul para las dimensiones (vista consolidada, sin semáforo) */
  private static readonly COLOR_DIMENSIONES = '#68B4D6';
  /** Naranja para las sucursales (vista consolidada, sin semáforo) */
  private static readonly COLOR_SUCURSALES = '#004A97';

  /** Color de la línea PROMEDIO en la vista de perspectiva (COMBO) */
  private static readonly COLOR_PROMEDIO = '#004A97';
  /** Un color por dimensión para las barras agrupadas de la vista de perspectiva */
  private static readonly COLORES_DIMENSIONES = ['#5EAEE5', '#8AD2E6', '#A4D55D', '#FFE370', '#FFAE5F', '#FB7598'];

  /** Ícono (Material) por dimensión para las cards del consolidado */
  private static readonly ICONOS_DIMENSION: { [k: string]: string } = {
    'liderazgo': 'hail',
    'motivacion': 'kitesurfing',
    'empoderamiento': 'sports_handball',
    'toma de decisiones': 'sensor_occupied',
    'comunicacion': 'forum',
    'trabajo en equipo': 'diversity_3',
  };

  public dimensiones: { name: string; check: boolean }[] = [];
  public dimensionConsolidado = true;
  public categoriasVista: { name: string; ponderacion: number | null }[] = [];

  /** Ejes demográficos del submenú Perspectiva (zona 1); '' = ninguna (vista normal) */
  public perspectivas: { key: string; name: string }[] = [];
  public perspectivaSel = '';
  /** Cruce perspectiva × sucursal (para que la perspectiva reaccione a la sucursal) */
  private cruce: AnonymousResultsCross | null = null;
  private cruceKey = '';

  public typesGraf = typesApex;
  data = [];
  labels = [];
  type = '';
  legend = '';
  colores = [];

  data2 = [];
  labels2 = [];
  type2 = '';
  legend2 = '';
  rangosColores = [];
  colores2 = [];

  public lineaRefZona1: number | null = null;
  public lineaRefZona2: number | null = null;

  public mostrarLineaZona1 = true;
  public mostrarLineaZona2 = true;

  public etiquetasZona1 = true;
  public etiquetasZona2 = true;

  /** Tipo de la vista de padres de zona 1 (barras/línea/área), lo controla el menú Gráficas */
  private typeZona1Normal: string = typesApex.BAR;

  public get lineaRefLabelZona1(): string {
    return this.lineaRefZona1 != null ? `Promedio: ${this.lineaRefZona1}` : 'Promedio';
  }

  public get lineaRefLabelZona2(): string {
    return this.lineaRefZona2 != null ? `Promedio: ${this.lineaRefZona2}` : 'Promedio';
  }

  public get periodoTitulo(): string {
    return this.etiquetaPeriodo(this.periodoSelect);
  }

  private get vistaPrincipal(): boolean {
    return this.sucursalConsolidado && this.dimensionConsolidado;
  }

  public get perspectivaActiva(): boolean {
    return !!this.perspectivaSel && !this.vistaDimension;
  }

  public get sucursalTitulo(): string {
    if(this.sucursalConsolidado) return '';
    return this.sucursalesSeleccionadas().join(', ');
  }

  public get dimensionTitulo(): string {
    if(this.dimensionConsolidado) return '';
    const d = this.dimensiones.find(x => x.check);
    return d ? d.name : '';
  }

  /** Alcance de las tarjetas de dimensiones: "Sucursal | nombre" si hay selección o "Consolidado" */
  public get tituloTarjetas(): string {
    if(!this.sucursalTitulo) return this.translate.instant('cues.resultados-clima.titulo-zon1-1');
    return this.translate.instant('cues.resultados-clima.titulo-zon2-1') + ' | ' + this.sucursalTitulo;
  }

  /** Sucursal(es) y/o dimensión unidas por " | "; "Consolidado" si no hay selección */
  public get segmentoSeleccion(): string {
    const partes: string[] = [];
    if(this.sucursalTitulo) partes.push(this.sucursalTitulo);
    if(this.dimensionTitulo) partes.push(this.dimensionTitulo);
    return partes.length
      ? partes.join(' | ')
      : this.translate.instant('cues.resultados-clima.titulo-zon1-1');
  }

  ampliar = false;
  ampliarGrafica1 = false;
  ampliarGrafica2 = false;
  @ViewChild('graficador1') graficador1: GraficadorComponent;
  @ViewChild('graficador2') graficador2: GraficadorComponent;


  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private resultadosService: ResultadosClimaService,
  ){
    this.type = this.typesGraf.BAR;
    this.type2 = this.typesGraf.BAR;
    this.getData();
    this.cargarPeriodos();
  }

  private async cargarPeriodos(){
    const cues = JSON.parse(localStorage.getItem('cuestionario'));
    const allocation = JSON.parse(localStorage.getItem('allocation'));
    this.questionnaireId = cues?.id != null ? String(cues.id) : '';
    this.institutionId = allocation?.['institution_id'] ?? '';
    this.maximoPonderacion = this.resultadosService.maximoEscala(this.institutionId);

    if(!this.institutionId){
      this.periodos = [];
      return;
    }

    let periods: AnonymousResultPeriod[] = [];
    try {
      periods = await this.resultadosService.getPeriods(this.institutionId);
    } catch (err) {
      this.periodos = [];
      return;
    }

    const propios = (periods || []).filter(
      p => String(p.questionnaireId) === this.questionnaireId
    );

    this.periodosPropios = [...propios].sort(
      (a, b) => (a.startDate || '').localeCompare(b.startDate || '')
    );

    this.construirFiltroPeriodos(propios);

    // El back viene ordenado por startDate desc -> el primero es el más reciente
    const reciente = propios[0];
    if (reciente) {
      this.allocationSelect = reciente.allocationId;
      this.periodoSelect = reciente.startDate;
      this.marcarPeriodo(reciente.allocationId);
      await this.cargarResultados(reciente.allocationId);
    } else {
      this.allocationSelect = null;
      this.resultado = null;
      this.poblarFiltros();
      this.recomputarCategorias();
    }
  }

  /** Carga el periodo y el anterior (comparativo), repuebla filtros y recalcula */
  private async cargarResultados(allocationId: number){
    this.loadingResultados = true;
    try {
      try {
        this.resultado = await this.resultadosService.getResults(allocationId, this.institutionId);
      } catch (err) {
        this.resultado = null;
      }

      const prev = this.periodoAnterior(allocationId);
      if(prev){
        try {
          this.resultadoPrevio = await this.resultadosService.getResults(prev.allocationId, this.institutionId);
        } catch (err) {
          this.resultadoPrevio = null;
        }
      } else {
        this.resultadoPrevio = null;
      }

      this.poblarFiltros();
      this.recomputarCategorias();
    } finally {
      this.loadingResultados = false;
    }
  }

  private periodoAnterior(allocationId: number): AnonymousResultPeriod | null {
    const idx = this.periodosPropios.findIndex(p => p.allocationId === allocationId);
    return idx > 0 ? this.periodosPropios[idx - 1] : null;
  }

  private poblarFiltros(){
    this.poblarSucursales();
    this.poblarDimensiones();
    this.poblarPerspectivas();
  }

  /** Perspectivas del submenú: ejes demográficos del resultado (edad, género, ...) */
  private poblarPerspectivas(){
    this.perspectivas = (this.resultado?.demographics ?? []).map(d => ({
      key: d.key,
      name: this.catalogoLabel(d.key, d.label),
    }));
    this.perspectivaSel = '';
    this.cruce = null;
    this.cruceKey = '';
  }

  /** Etiqueta legible de una key demográfica; cae al fallback del back si no hay traducción */
  private catalogoLabel(key: string, fallback: string): string {
    const ruta = 'cues.cuestionariov2.catalogos.' + key;
    const val = this.translate.instant(ruta);
    return val !== ruta ? val : (fallback || key);
  }

  /** Sucursales del filtro: solo valores reales de demographics (ignora placeholders) */
  private poblarSucursales(){
    const reales = this.valoresSucursal(this.resultado?.demographics).filter(
      v => v.count > 0 && !ResultadosComponent.SUCURSAL_PLACEHOLDERS.includes(v.value)
    );

    this.sucursalesDisponibles = reales.length > 0;
    this.sucursales = reales.map(v => ({ name: v.value, check: false }));
    this.sucursalConsolidado = true;
  }

  /** Dimensiones del filtro: parentCategoryName únicos (dimensiones padre) */
  private poblarDimensiones(){
    this.dimensiones = this.padresUnicos(this.resultado).map(n => ({ name: n, check: false }));
    this.dimensionConsolidado = true;
  }

  // --- Helpers de lectura del resultado ---

  /** Nombres únicos de dimensión padre (parentCategoryName) */
  private padresUnicos(res: AnonymousResults | null): string[] {
    const nombres = (res?.categories ?? [])
      .map(c => (c.parentCategoryName || '').trim())
      .filter(n => !!n);
    return Array.from(new Set(nombres));
  }

  /** Categorías hijas de una dimensión padre */
  private hijasDe(res: AnonymousResults | null, padre: string): AnonymousResultCategory[] {
    return (res?.categories ?? []).filter(c => (c.parentCategoryName || '').trim() === padre);
  }

  /** Valores de Sucursal (branch-office) dentro de un arreglo de demographics */
  private valoresSucursal(demographics: DemographicBreakdown[] | undefined): DemographicValue[] {
    return demographics?.find(d => d.key === ResultadosComponent.KEY_SUCURSAL)?.values ?? [];
  }

  /** Nombres de las sucursales marcadas en el filtro */
  private sucursalesSeleccionadas(): string[] {
    return this.sucursales.filter(s => s.check).map(s => s.name);
  }

  /** Promedio ponderado por peso; null si la suma de pesos es 0 */
  private ponderadoEstricto(datos: { score: number; peso: number }[]): number | null {
    const pesos = datos.reduce((a, d) => a + d.peso, 0);
    if(!pesos) return null;
    const suma = datos.reduce((a, d) => a + d.score * d.peso, 0);
    return Number((suma / pesos).toFixed(2));
  }

  /** Promedio ponderado por peso; sin pesos cae a promedio simple; null si no hay datos */
  private ponderadoConFallback(datos: { score: number; peso: number }[]): number | null {
    if(!datos.length) return null;
    const pesos = datos.reduce((a, d) => a + d.peso, 0);
    const val = pesos > 0
      ? datos.reduce((a, d) => a + d.score * d.peso, 0) / pesos
      : datos.reduce((a, d) => a + d.score, 0) / datos.length;
    return Number(val.toFixed(2));
  }

  /** Normaliza para comparar sin acentos ni mayúsculas */
  private normalizar(txt: string): string {
    return (txt || '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  /** Ícono Material según la dimensión (genérico si no está mapeada) */
  public iconoDimension(name: string): string {
    //habilitar si se encuentran los iconos adecuados
    //return ResultadosComponent.ICONOS_DIMENSION[this.normalizar(name)] ?? 'accessibility_new';
    return '';
  }

  /** Recalcula cards y gráficas según los filtros (con/sin dimensión, alcance de Sucursal) */
  private recomputarCategorias(){
    const seleccionada = this.dimensiones.find(d => d.check);

    if(!seleccionada){
      this.categoriasVista = this.computarPadres();
      this.vistaDimension = null;
      this.recomputarComparativo();
    } else {
      this.categoriasVista = [];
      this.comparativo = null;
      this.recomputarVistaDimension(seleccionada);
    }

    this.lineaRefZona1 = this.promedioZona1();
    this.lineaRefZona2 = this.promedioZona2();

    this.getGraficaZona1();
    this.getGraficaZona2();
  }

  /** Cards de la vista de dimensión seleccionada: Universo, Muestra, Score y Promedio (actual vs anterior) */
  private recomputarVistaDimension(sel: { name: string }){
    if(!this.resultado){ this.vistaDimension = null; return; }

    // Universo = encuestas enviadas del periodo; muestra = los que contestaron
    const periodo = this.periodosPropios.find(p => p.allocationId === this.allocationSelect);
    const universo = this.resultadosService.universoDe(periodo, this.resultado.totalResponses ?? 0);

    let muestra = this.resultado.totalResponses ?? 0;
    if(!this.sucursalConsolidado){
      const seleccion = this.sucursalesSeleccionadas();
      muestra = this.valoresSucursal(this.resultado.demographics)
        .filter(v => seleccion.includes(v.value))
        .reduce((a, v) => a + v.count, 0);
    }
    const muestraPct = universo > 0 ? Math.round(muestra / universo * 100) : 0;

    const hijas = this.hijasDe(this.resultado, sel.name);
    const score = this.scorePadre(hijas);
    const sucLabel = this.sucursalConsolidado
      ? 'Consolidado'
      : this.sucursalesSeleccionadas().join(', ');

    // Card 4: con sucursal(es) se re-escopa por sucursal; en consolidado es el promedio GLOBAL
    let actual: number | null;
    let anterior: number | null;
    if(this.sucursalConsolidado){
      actual = this.scorePadreGlobalDe(this.resultado, sel.name);
      anterior = this.scorePadreGlobalDe(this.resultadoPrevio, sel.name);
    } else {
      actual = this.scorePadre(hijas);
      anterior = this.scorePadre(this.hijasDe(this.resultadoPrevio, sel.name));
    }
    const prev = this.allocationSelect != null ? this.periodoAnterior(this.allocationSelect) : null;

    let tendencia: 'up' | 'down' | 'eq' | null = null;
    if(prev && actual != null && anterior != null){
      tendencia = actual > anterior ? 'up' : actual < anterior ? 'down' : 'eq';
    }

    this.vistaDimension = {
      dimension: sel.name,
      universo,
      muestra,
      muestraPct,
      sucLabel,
      score,
      actual,
      anterior: prev ? anterior : null,
      anioActual: this.anioDe(this.periodoSelect),
      anioAnterior: prev ? this.anioDe(prev.startDate) : null,
      tendencia,
    };
  }

  /** Promedio GLOBAL (todas las sucursales) de una dimensión padre en una evaluación */
  private scorePadreGlobalDe(res: AnonymousResults | null, padre: string): number | null {
    const datos = this.hijasDe(res, padre)
      .filter(h => h.averageScore != null)
      .map(h => ({
        score: h.averageScore as number,
        peso: this.valoresSucursal(h.demographics).reduce((a, v) => a + v.count, 0),
      }));
    return this.ponderadoConFallback(datos);
  }

  private anioDe(startDate: string): string {
    return (startDate || '').split('-')[0] || '';
  }

  /** Cards de comparación actual vs evaluación anterior (score cortado por Sucursal) */
  private recomputarComparativo(){
    if(!this.resultado){
      this.comparativo = null;
      return;
    }

    const actualScore = this.overallScoped(this.resultado);
    const prev = this.allocationSelect != null ? this.periodoAnterior(this.allocationSelect) : null;

    let anterior: { label: string; score: number | null } | null = null;
    let tendencia: 'up' | 'down' | 'eq' | null = null;

    if(prev && this.resultadoPrevio){
      const anteriorScore = this.overallScoped(this.resultadoPrevio);
      anterior = {
        label: 'Evaluación ' + this.etiquetaPeriodo(prev.startDate),
        score: anteriorScore,
      };
      if(actualScore != null && anteriorScore != null){
        tendencia = actualScore > anteriorScore ? 'up'
                  : actualScore < anteriorScore ? 'down' : 'eq';
      }
    }

    this.comparativo = {
      actual: {
        label: 'Evaluación ' + this.etiquetaPeriodo(this.periodoSelect),
        score: actualScore,
        tendencia,
      },
      anterior,
    };
  }

  /** Score global según el alcance de Sucursal: consolidado usa overallAverageScore; si no, ponderado por count */
  private overallScoped(res: AnonymousResults | null): number | null {
    if(!res) return null;

    if(this.sucursalConsolidado){
      return res.overallAverageScore != null
        ? Number(Number(res.overallAverageScore).toFixed(2)) : null;
    }

    const seleccion = this.sucursalesSeleccionadas();
    const datos = this.valoresSucursal(res.demographics)
      .filter(v => seleccion.includes(v.value) && v.averageScore != null)
      .map(v => ({ score: v.averageScore as number, peso: v.count }));
    return this.ponderadoEstricto(datos);
  }

  /** Línea de referencia de zona 1: promedio del alcance actual (sigue Sucursal y Dimensión) */
  private promedioZona1(): number | null {
    const sel = this.dimensiones.find(d => d.check);
    if(sel){
      return this.scorePadre(this.hijasDe(this.resultado, sel.name));
    }
    return this.overallScoped(this.resultado);
  }

  /** Línea de referencia de zona 2: promedio consolidado (todas las sucursales) de la Dimensión */
  private promedioZona2(): number | null {
    const sel = this.dimensiones.find(d => d.check);
    if(!sel){
      const overall = this.resultado?.overallAverageScore;
      return overall != null ? Number(Number(overall).toFixed(2)) : null;
    }
    // Mismo cálculo que el global de la dimensión (sobre todas las sucursales)
    return this.scorePadreGlobalDe(this.resultado, sel.name);
  }

  /** Etiqueta corta de un periodo por su startDate (ej. "dic 25") */
  private etiquetaPeriodo(startDate: string): string {
    const [y, m] = (startDate || '').split('-');
    if(!y || !m) return '';
    const mes = Meses.getMesesNumbertoString(Number(m), true);
    return `${mes} ${y.substring(2)}`;
  }

  /** Zona "Por sucursal": una barra por sucursal (score cortado por Dimensión); atenúa las no enfocadas */
  private getGraficaZona2(){
    const nombres = this.sucursales.map(s => s.name);
    if(nombres.length === 0){
      this.labels2 = [];
      this.data2 = [] as any;
      this.colores2 = [] as any;
      return;
    }

    const sel = this.dimensiones.find(d => d.check);
    const scores = nombres.map(n => this.scoreSucursal(n, sel));

    this.labels2 = nombres;
    this.data2 = [
      { name: 'Sucursales', data: scores.map(s => s ?? 0) },
    ] as any;

    const sucSel = this.sucursales.find(s => s.check);
    this.colores2 = nombres.map((n, i) => {
      if(this.vistaPrincipal){
        return ResultadosComponent.COLOR_SUCURSALES;
      }
      const color = this.colorSemaforo(scores[i]);
      return (sucSel && n !== sucSel.name) ? this.aplicarOpacidad(color, 0.3) : color;
    }) as any;
  }

  /** Convierte un color hex (#RRGGBB) a rgba() con la opacidad indicada */
  private aplicarOpacidad(color: string, alpha: number): string {
    const hex = (color || '').replace('#', '');
    if(hex.length !== 6) return color;
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  /** Score de una sucursal: sin dimensión, su averageScore; con dimensión, ponderado por count de las hijas */
  private scoreSucursal(name: string, sel: { name: string } | undefined): number | null {
    // Sin dimensión: el averageScore de la sucursal a nivel raíz
    if(!sel){
      const v = this.valoresSucursal(this.resultado?.demographics).find(x => x.value === name);
      return v?.averageScore != null ? Number(Number(v.averageScore).toFixed(2)) : null;
    }

    // Con dimensión: promedio de las hijas ponderado por los respondientes de esa sucursal
    const datos: { score: number; peso: number }[] = [];
    for(const h of this.hijasDe(this.resultado, sel.name)){
      const v = this.valoresSucursal(h.demographics).find(x => x.value === name);
      if(v && v.averageScore != null){
        datos.push({ score: v.averageScore as number, peso: v.count });
      }
    }
    return this.ponderadoEstricto(datos);
  }

  /** Una entrada por dimensión padre con su score agregado (bajo el alcance de Sucursal) */
  private computarPadres(): { name: string; ponderacion: number | null }[] {
    return this.padresUnicos(this.resultado).map(padre => ({
      name: padre,
      ponderacion: this.scorePadre(this.hijasDe(this.resultado, padre)),
    }));
  }

  /** Zona 1: sin dimensión, padres en vertical; con dimensión, sus hijas en horizontal */
  private getGraficaZona1(){
    const sel = this.dimensiones.find(d => d.check);

    if(!sel && this.perspectivaSel){
      this.getGraficaPerspectiva();
      return;
    }

    if(sel){
      this.type = this.typesGraf.BARHORIZONTAL;
      const hijas = this.computarHijas(sel);
      this.labels = hijas.map(h => h.name);
      this.data = [{
        name: 'Ponderación',
        data: hijas.map(h => h.ponderacion ?? 0),
      }] as any;
      this.colores = hijas.map(h => this.colorSemaforo(h.ponderacion)) as any;
      return;
    }

    this.type = this.typeZona1Normal;
    const padres = this.computarPadres();
    this.labels = padres.map(p => p.name);
    this.data = [{
      name: 'Ponderación',
      data: padres.map(p => p.ponderacion ?? 0),
    }] as any;
    this.colores = this.vistaPrincipal
      ? padres.map(() => ResultadosComponent.COLOR_DIMENSIONES)
      : padres.map(p => this.colorSemaforo(p.ponderacion)) as any;
  }

  private computarHijas(sel: { name: string }): { name: string; ponderacion: number | null }[] {
    return this.hijasDe(this.resultado, sel.name).map(c => ({
      name: c.categoryName,
      ponderacion: this.scoreCategoria(c),
    }));
  }

  /** Zona 1 en modo perspectiva: barras agrupadas (dimensiones) por valor demográfico + línea PROMEDIO (COMBO) */
  private getGraficaPerspectiva(){
    const key = this.perspectivaSel;
    const breakdown = this.resultado?.demographics?.find(d => d.key === key);
    const valores = (breakdown?.values ?? []).filter(
      v => v.count > 0 && !ResultadosComponent.SUCURSAL_PLACEHOLDERS.includes(v.value)
    );
    const ejes = valores.map(v => v.value);

    this.type = this.typesGraf.COMBO;
    this.labels = ejes as any;

    // Con cruce cargado los datos reaccionan a la sucursal; si no, marginal global
    const { promedio, series } = this.cruce
      ? this.seriesPerspectivaCruce(this.cruce, ejes)
      : this.seriesPerspectivaMarginal(key, ejes, valores);

    this.data = [promedio, ...series] as any;
    this.colores = [
      ResultadosComponent.COLOR_PROMEDIO,
      ...series.map((_, i) => ResultadosComponent.COLORES_DIMENSIONES[i % ResultadosComponent.COLORES_DIMENSIONES.length]),
    ] as any;
  }

  /** Series de perspectiva desde los marginales globales (sin cruce; no reacciona a sucursal) */
  private seriesPerspectivaMarginal(key: string, ejes: string[], valores: DemographicValue[]){
    const promedio = { name: 'Promedio', data: valores.map(v => v.averageScore ?? 0) };
    const series = this.padresUnicos(this.resultado).map(p => ({
      name: p,
      data: ejes.map(a => this.scorePadrePorValor(p, key, a) ?? 0),
    }));
    return { promedio, series };
  }

  /** Series de perspectiva desde el cruce perspectiva × sucursal (reacciona a la sucursal) */
  private seriesPerspectivaCruce(cruce: AnonymousResultsCross, ejes: string[]){
    const sucursales = this.sucursalConsolidado ? null : this.sucursalesSeleccionadas();

    const series = cruce.categories.map(dim => ({
      name: dim.categoryName,
      data: ejes.map(eje => this.scoreDimensionCruce(dim, eje, sucursales).score ?? 0),
    }));
    const promedio = {
      name: 'Promedio',
      data: ejes.map(eje => this.promedioEjeCruce(cruce.categories, eje, sucursales) ?? 0),
    };
    return { promedio, series };
  }

  /** Score de una dimensión para un valor del eje: marginal (consolidado) o celdas de la(s) sucursal(es) */
  private scoreDimensionCruce(dim: CrossCategory, eje: string, sucursales: string[] | null): { score: number | null; peso: number } {
    if(sucursales == null){
      const marginal = dim.marginalsA.find(m => m.value === eje);
      return { score: marginal?.averageScore ?? null, peso: marginal?.count ?? 0 };
    }
    const celdas = dim.cells
      .filter(c => c.valueA === eje && sucursales.includes(c.valueB) && c.averageScore != null)
      .map(c => ({ score: c.averageScore as number, peso: c.count }));
    return { score: this.ponderadoConFallback(celdas), peso: celdas.reduce((s, c) => s + c.peso, 0) };
  }

  /** Promedio de un valor del eje: pondera las dimensiones por sus respondientes */
  private promedioEjeCruce(dims: CrossCategory[], eje: string, sucursales: string[] | null): number | null {
    const datos = dims
      .map(d => this.scoreDimensionCruce(d, eje, sucursales))
      .filter(x => x.score != null)
      .map(x => ({ score: x.score as number, peso: x.peso }));
    return this.ponderadoConFallback(datos);
  }

  /** Color del semáforo (0–10). Con huecos entre rangos, cae al inferior */
  public colorSemaforo(score: number | null): string {
    if(score == null) return '#BDBDBD';
    if(!this.semaforos.length) return '#BDBDBD';

    const exacto = this.semaforos.find((s: any) => s.min <= score && score <= s.max);
    if(exacto) return (exacto as any).color;

    const inferiores = this.semaforos.filter((s: any) => score >= s.min);
    if(inferiores.length){
      const sem = inferiores.reduce((a: any, b: any) => (b.min > a.min ? b : a));
      return sem.color;
    }

    const menor = this.semaforos.reduce((a: any, b: any) => (b.min < a.min ? b : a));
    return menor ? (menor as any).color : '#BDBDBD';
  }

  /** Score de una categoría hija: consolidado usa averageScore; si no, ponderado por count del alcance */
  private scoreCategoria(cat: AnonymousResultCategory): number | null {
    if(this.sucursalConsolidado){
      return cat.averageScore != null ? Number(Number(cat.averageScore).toFixed(2)) : null;
    }

    const seleccion = this.sucursalesSeleccionadas();
    const datos = this.valoresSucursal(cat.demographics)
      .filter(v => seleccion.includes(v.value) && v.averageScore != null)
      .map(v => ({ score: v.averageScore as number, peso: v.count }));
    return this.ponderadoEstricto(datos);
  }

  /** Score de una dimensión padre: promedio de hijas ponderado por respondientes (simple si no hay counts) */
  private scorePadre(hijas: AnonymousResultCategory[]): number | null {
    const datos: { score: number; peso: number }[] = [];
    for(const h of hijas){
      const score = this.scoreCategoria(h);
      if(score == null) continue;
      datos.push({ score, peso: this.countCategoria(h) });
    }
    return this.ponderadoConFallback(datos);
  }

  /** Score de una dimensión padre para un valor demográfico (ponderado por las hijas) */
  private scorePadrePorValor(padre: string, key: string, value: string): number | null {
    const datos: { score: number; peso: number }[] = [];
    for(const h of this.hijasDe(this.resultado, padre)){
      const v = h.demographics?.find(d => d.key === key)?.values.find(x => x.value === value);
      if(v && v.averageScore != null){
        datos.push({ score: v.averageScore, peso: v.count });
      }
    }
    return this.ponderadoConFallback(datos);
  }

  /** Respondientes de una categoría bajo el alcance de Sucursal actual */
  private countCategoria(cat: AnonymousResultCategory): number {
    const valores = this.valoresSucursal(cat.demographics);
    if(this.sucursalConsolidado){
      return valores.reduce((a, v) => a + v.count, 0);
    }
    const seleccion = this.sucursalesSeleccionadas();
    return valores.filter(v => seleccion.includes(v.value)).reduce((a, v) => a + v.count, 0);
  }

  /** Filtro de Sucursal (selección única). Bloqueado en consolidado si no hay reales */
  public sucursalChange(click: any){
    if(!this.sucursalesDisponibles) return;

    if(click === 'consolidado'){
      this.sucursalConsolidado = !this.sucursalConsolidado;
      if(this.sucursalConsolidado){
        this.sucursales.forEach(s => s.check = false);
      } else {
        // Al desmarcar "seleccionar todas" se marca la primera sucursal
        this.sucursales.forEach((s, i) => s.check = i === 0);
      }
      this.recomputarCategorias();
      return;
    }

    const suc = this.sucursales.find(s => s.name === click?.name);
    if(!suc) return;

    const yaEstaba = suc.check;
    this.sucursales.forEach(s => s.check = false);
    suc.check = !yaEstaba;

    this.sucursalConsolidado = !suc.check;
    this.recomputarCategorias();
  }

  /** Filtro de Dimensión (selección única): consolidado o exactamente una dimensión */
  public dimensionChange(click: any){
    if(click === 'consolidado'){
      this.dimensionConsolidado = !this.dimensionConsolidado;
      if(this.dimensionConsolidado){
        this.dimensiones.forEach(d => d.check = false);
      } else {
        // Al desmarcar "seleccionar todos" se marca la primera dimensión
        this.dimensiones.forEach((d, i) => d.check = i === 0);
      }
      this.recomputarCategorias();
      return;
    }

    const dim = this.dimensiones.find(d => d.name === click?.name);
    if(!dim) return;

    const yaEstaba = dim.check;
    this.dimensiones.forEach(d => d.check = false);
    dim.check = !yaEstaba;

    this.dimensionConsolidado = !dim.check;
    this.recomputarCategorias();
  }

  /** Regresa Sucursal, Dimensión y Perspectiva a su estado consolidado inicial */
  public async borrarFiltros(): Promise<void> {
    this.sucursales.forEach(s => s.check = false);
    this.sucursalConsolidado = true;

    this.dimensiones.forEach(d => d.check = false);
    this.dimensionConsolidado = true;

    await this.cambiarPerspectiva('');
  }

  /** Click en barra de zona 1: equivale a elegir esa dimensión (drilea a sus hijas) */
  public barraClick(event: any){
    const nombre = (event?.name ?? '').trim();
    if(!nombre) return;
    if(!this.dimensiones.some(d => d.name === nombre)) return;
    this.dimensionChange({ name: nombre });
  }

  /** Click en barra de zona 2: equivale a elegir esa sucursal en el filtro */
  public sucursalBarraClick(event: any){
    const nombre = (event?.name ?? '').trim();
    if(!nombre) return;
    if(!this.sucursales.some(s => s.name === nombre)) return;
    this.sucursalChange({ name: nombre });
  }

  /** Arma la estructura (año → series de meses) que consume app-filters PERIOD */
  private construirFiltroPeriodos(periods: AnonymousResultPeriod[]){
    const porAnio = new Map<string, any>();

    for(const p of periods){
      const [y, m] = (p.startDate || '').split('-');
      if(!y || !m) continue;

      if(!porAnio.has(y)){
        porAnio.set(y, { anio: Number(y), visible: true, utilizable: true, series: [] });
      }
      const mesKey = Meses.getMesesNumbertoString(Number(m), true);
      porAnio.get(y).series.push({
        mes: mesKey,
        mesS: mesKey,
        anio: y.substring(2),
        label: `${mesKey} ${y.substring(2)}`,
        periodo: String(p.allocationId),
        allocationId: p.allocationId,
        startDate: p.startDate,
        check: false,
        visible: true,
        utilizable: true,
      });
    }

    const arr = Array.from(porAnio.values()).sort((a, b) => a.anio - b.anio);
    arr.forEach(a => a.series.sort((x, y) => x.startDate.localeCompare(y.startDate)));
    this.periodos = arr;
  }

  private marcarPeriodo(allocationId: number){
    this.periodos.forEach(anio => {
      anio.series.forEach(per => {
        per.check = per.allocationId === allocationId;
      });
    });
  }

  public async yearChange(event){
    const allocationId = event?.allocationId;
    if(allocationId == null) return;

    this.allocationSelect = allocationId;
    this.periodoSelect = event.startDate ?? this.periodoSelect;
    this.marcarPeriodo(allocationId);
    await this.cargarResultados(allocationId);
  }

  /** Carga del cuestionario (localStorage): nombre para títulos y semáforos para colorear */
  private getData(){
    const cues = JSON.parse(localStorage.getItem('cuestionario'));
    const allocation = JSON.parse(localStorage.getItem('allocation'));
    this.cuestionario_name = cues.name;

    this.semaforos = [];
    var aux = JSON.parse(JSON.stringify(cues.semaphores));
    aux.sort( function(a,b){
      if ( Number(a.value_1) < Number(b.value_1) ) {
        return 1;
      }
      if ( Number(a.value_1) > Number(b.value_1) ) {
        return -1;
      }
      return 0;
    });
    var titN = 1;

    for(const sem of aux){
      var name = this.translate.instant('cues.resultados.titulo-semaforo-'+titN);
      if(name === ('cues.resultados.titulo-semaforo-'+titN)){
        name = '';
      }
      this.semaforos.push({
        name: name,
        min: Number(sem.value_1),
        max: Number(sem.value_2),
        color: sem.color
      });
      titN++;
    }
    this.semaforos = this.resultadosService.escalarSemaforos(this.semaforos, allocation?.['institution_id'] ?? '');
    this.rangosColores = this.semaforos.map((s: any) => ({
      from: s.min, to: s.max, color: s.color,
    })) as any;
  }

  public ampliarGraficas(zona){
    this.ampliar = true;
    switch(zona){
      case 1:
        this.ampliarGrafica1 = true;
        break;
      case 2:
        this.ampliarGrafica2 = true;
        break;
    }
  }

  public cerrarGraficas(){
    this.ampliar = false;
    this.ampliarGrafica1 = false;
    this.ampliarGrafica2 = false;
  }

  public exportarGrafica1() {
    this.exportarZona(this.ampliarGrafica1 ? 1 : 2);
  }

  /** Menú 3 puntos: cambia el tipo de gráfica (barras/línea/área) de la zona indicada */
  public cambiarTipoGrafica(zona: number, tipo: string){
    if(zona === 1){
      // Con una dimensión, zona 1 siempre va horizontal; se guarda para volver a padres
      this.typeZona1Normal = tipo;
      if(!this.dimensiones.some(d => d.check)){
        this.type = tipo;
      }
    } else {
      this.type2 = tipo;
    }
  }

  /** Submenú Perspectiva: reagrupa la zona 1 por un eje demográfico ('' = ninguna) */
  public async cambiarPerspectiva(key: string){
    this.perspectivaSel = key;
    this.cruce = null;
    this.cruceKey = '';
    // Solo se cruza con sucursal si hay sucursales reales; si no, basta el marginal
    if(key && this.sucursalesDisponibles){
      await this.cargarCruce(key);
    }
    this.recomputarCategorias();
  }

  /** Trae el cruce perspectiva × sucursal (una sola vez por eje; trae todas las sucursales) */
  private async cargarCruce(key: string){
    if(this.allocationSelect == null) return;
    this.loadingResultados = true;
    try {
      this.cruce = await this.resultadosService.getCross(this.allocationSelect, this.institutionId, key, ResultadosComponent.KEY_SUCURSAL);
      this.cruceKey = key;
    } catch {
      this.cruce = null;
      this.cruceKey = '';
    }
    this.loadingResultados = false;
  }

  /** Botón x̄: muestra u oculta la línea de promedio global de la zona indicada */
  public toggleLineaZona(zona: number){
    if(zona === 1){
      this.mostrarLineaZona1 = !this.mostrarLineaZona1;
    } else {
      this.mostrarLineaZona2 = !this.mostrarLineaZona2;
    }
  }

  /** Menú 3 puntos: exporta como imagen la gráfica de la zona indicada */
  public exportarZona(zona: number){
    const key = zona === 1 ? 'titulo-zon1' : 'titulo-zon2';
    const titulos = {
      titulo: this.translate.instant('cues.resultados-clima.' + key),
      subtitulo: this.cuestionario_name,
      nombreArch: 'resultados-clima-zona' + zona,
    };
    const graf = zona === 1 ? this.graficador1 : this.graficador2;
    if(graf){
      graf.exportImg(zona, titulos);
    }
  }

}
